import { useMemo } from 'react';
import { parseVacationStatus } from '@features/vacation/utils/parseVacationStatus';

// 휴가 현황 데이터 가공 훅
export default function useVacationStatus(remainVacationData) {
  return useMemo(() => {
    return parseVacationStatus(remainVacationData?.remainVacation);
  }, [remainVacationData]);
}
